import { UNIT } from '~/environment-variables/unit.const'
import type { Column } from '~/ui/Table/types'

const blockListColumn: Array<Column> = [
  {
    name: 'BLOCK',
    field: 'BNO',
    isToggleColumn: false,
  },
  {
    name: 'AGE',
    field: 'AG',
    isToggleColumn: true,
    tooltip: 'click to show Timestamp'
  },
  {
    name: 'DATETIME',
    field: 'unixTimeStamp',
    isToggleColumn: true,
    tooltip: 'click to show Age'
  },
  {
    name: 'TXN',
    field: 'TRXCNT',
    isToggleColumn: false,
  },
  {
    name: 'VALIDATOR',
    field: 'VD',
    isToggleColumn: false,
  },
  {
    name: 'GAS USED',
    field: 'gasUsed',
    isToggleColumn: false,
  },
  {
    name: 'GAS LIMIT',
    field: 'gasLimit',
    isToggleColumn: false,
    isHoverable: true,
  },
  {
    name: 'BASE FEE',
    field: 'baseFeePerGasGwei',
    isToggleColumn: false,
    unit: 'Gwei',
    isHoverable: true,
  },
  {
    name: 'REWARD',
    field: 'blockReward',
    isToggleColumn: false,
    unit: UNIT,
    isHoverable: true,
  },
  {
    name: `GAS FEES (${UNIT})`,
    field: 'burntFees',
    isToggleColumn: false,
  },
]

export { blockListColumn }